// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import trendUp01Icon from "@/assets/icons/trend-up-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type TrendUp01IconProps = Omit<IconProps, "name">;

export function TrendUp01Icon(props: TrendUp01IconProps): React.ReactNode {
  return <Icon name={trendUp01Icon} {...props} />;
}
